// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorPlanModels {
    static getAttributeTypeMap() {
        return PayorPlanModels.attributeTypeMap;
    }
}
PayorPlanModels.discriminator = undefined;
PayorPlanModels.additionalProperties = false;
PayorPlanModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=payorPlanModels.js.map